import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mt-10 mb-20" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-12 sticky top-10 bg-white py-2 z-50"
}
const _hoisted_3 = { class: "col-span-6 flex items-center justify-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-5 mx-1 text-xl" }, "検索履歴", -1)
const _hoisted_5 = { class: "col-span-6 flex items-center justify-end mt-5 mr-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-2" }, null, -1)
const _hoisted_7 = { class: "py-2 px-3 grid grid-cols-12 hover:bg-gray-100" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-base text-gray-500 truncate" }
const _hoisted_10 = { class: "col-span-1 flex items-center justify-end md:pr-5" }
const _hoisted_11 = {
  key: 2,
  class: "py-2 px-3 text-gray-500"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tickets = _resolveComponent("Tickets")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_Stopwatch = _resolveComponent("Stopwatch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (!_ctx.store.state.base.responsive.isSM)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, { class: "text-xl mt-5 ml-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Tickets)
                ]),
                _: 1
              }),
              _hoisted_4
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_base_svg_icon, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.dispatch('layout/switchsearchHistoryOpen'),_ctx.store.dispatch('layout/pcSearchingOff'))),
                class: "w-6 cursor-pointer",
                path: _ctx.mdiClose
              }, null, 8, ["path"])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_6,
      (_ctx.toArray(_ctx.search_histories).length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.search_histories, (search_history, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: search_history.id
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.onSearchHistory(search_history.search_word)),
                  class: "col-span-11 flex items-center justify-start md:ml-5"
                }, [
                  _createVNode(_component_el_icon, { class: "mr-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Stopwatch)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("label", _hoisted_9, _toDisplayString(search_history.search_word), 1)
                ], 8, _hoisted_8),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_svg_icon, {
                    onClick: ($event: any) => (_ctx.deleteSearchHistory(search_history.id,index)),
                    class: "w-6 cursor-pointer text-gray-500",
                    path: _ctx.mdiMinusCircleOutline
                  }, null, 8, ["onClick", "path"])
                ])
              ])
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("p", _hoisted_11, "検索履歴がありません")),
      _hoisted_12
    ])
  ]))
}